export default function currencyFormat(num: number) {
	return Intl.NumberFormat('en-IN', {
		style: 'currency', currency: 'INR'
	}).format(num)
}